import React,{useState,useEffect} from 'react'
import Template from '../Components/Template'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAddEventYearMutation, useDeleteEventYearMutation, useGetAllYearsQuery } from '../Services/modules/PhotoGallery';
import useDataTable from '../hooks/useDataTable';
import { updateGalleryData } from '../Store/GalleryData';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WarningModal from '../Components/WarningModal';
import { MdOutlineNavigateNext,MdSkipNext,MdSkipPrevious,MdEdit, MdDelete   } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import { useAddYoutubeVideoMutation, useDeleteYoutubeVideoMutation, useGetAllYoutubeVideosQuery } from '../Services/modules/VideoGallery';

function VideoGallery() {
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const {   
    handleFirstPage ,
    handlePageSizeChange,
    handleLastPage,
    sequenceStartIndex  ,
    page,
    rowsPerPage,
    totalRows,
    setTotalRows,
    setPage,
    setTotalPages,
    totalPages
    // Add other state variables and functions here
  }=useDataTable()
  const{
    data=[],
    isSuccess,
    isLoading,
    error,
    refetch
  }=useGetAllYoutubeVideosQuery({page_number:page,page_size:rowsPerPage})
  const [video_data, setVideoData] = useState({
    video_link:"",     
  });
  const[isDelete,setIsDelete]=useState(false) 
  const[isDeleteModal,setDeleteModal]=useState(false)
  const[allVideos,setAllVideos]=useState([])
  const [isSumbmiting,setIsSubmitting]=useState(false)

  const [AddVideo, { 
    data:addData,
     isSuccess:addIsSuccess, 
     isLoading:addIsLoading, 
     isError:addIsError,
    error:addError }] = useAddYoutubeVideoMutation();
  const [DeleteVideo, { 
    data:deleteData=[], 
    isSuccess:deleteIsSuccess, 
    isLoading:deleteIsLoading, 
    isError:deleteIsError, 
    error:deleteError }] = useDeleteYoutubeVideoMutation();

    function handleChange(name, value) {
        setVideoData({
        ...video_data,
        [name]: value
      });
    }
 const handleVideoDelete=(dataRow)=>{
       console.log("In handle product delete dataRow",dataRow)
        setDeleteModal(true)
        setVideoData({
          ...video_data,
          video_id:dataRow._id,         
        });

      }
      useEffect(() => {
        refetch();
      }, [page]);

      useEffect(()=>{

        if(isSuccess)
        {
          console.log("dataProduct kddddddddd",data)
          setAllVideos(data.data)
          setTotalRows(data.totalRows)
          setVideoData({                       
            video_link:""     
          })

        }
          },[data])
          useEffect(() => {
            if(addIsSuccess)
            {
              toast.success(addData.message)
              setIsSubmitting(false)
              refetch()

            }
          },[addData])
          useEffect(() => {
            if(deleteIsSuccess)
            {
              toast.success(deleteData.message)
              setIsDelete(false)
              setDeleteModal(false)
              refetch()
            }
          },[deleteData])

          useEffect(() => {
           
            if(isDelete)
            {
              DeleteVideo(video_data)
            }
           
          
          
          }, [isDelete]);

         
           const onSubmit=()=>{
          setIsSubmitting(true)
              AddVideo(video_data)
    
            
          }
    
    const videoGalleryScreen=()=>{
      return(
        <>
        <ToastContainer/>
        <
                WarningModal
                setShowWarningModal={setDeleteModal}
                modalTitle={"Delete Product"}
                setIsDelete={setIsDelete}
                showModal={isDeleteModal}
              />
              <main id="main" class="main">
                <div className='container'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='card'>
                        <div className='card-body'>
              <h5 className="card-title">Add Video Link</h5>
              <div className="form-group">
                  <label htmlFor="input1">Video Link</label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="video_link"
                  value={video_data.video_link}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                   />
                </div>
                <button type="submit" 
                className="btn btn-primary"              
                onClick={()=>onSubmit()}
                >
                   {isSumbmiting ? 
                  'Submitting...' :                  
                  'Submit'} 
                 
                </button>
                        </div>
                      </div>
                    </div>
                  
                    <div className='col-md-6'>
                    <div className='card'>
                        <div className='card-body'>
                        <table className="bordered-table">
        <thead>
          <tr>
          <th>Action</th>
            <th>Index</th>
            <th>Video</th>
            {/* Add more column headers as needed */}
          </tr>
        </thead>
        <tbody>
          {allVideos?.map((item, index) => (
            <tr key={index}>
              <td>                
              <MdDelete onClick={()=>handleVideoDelete(item)} style={{cursor:'pointer'}}/>
              </td>
              <td>{sequenceStartIndex + index}</td>
              <td>
              <iframe width="560" height="315" 
                    src={`https://www.youtube.com/embed/${item.video_id}`}
                    
                    frameborder="0" allowfullscreen></iframe>  

                {/* {item.embed_link} */}
                
                </td>             
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={() => handleFirstPage()} disabled={page === 0}><MdSkipPrevious/></button>
      <button onClick={() => setPage(page - 1)} disabled={page === 0}><GrFormPrevious/></button>
      <button onClick={() => setPage(page + 1)} disabled={page === totalPages - 1}><MdOutlineNavigateNext /></button>
      <button onClick={() => handleLastPage()} disabled={page === totalPages - 1}><MdSkipNext/></button>
      <div>
        <select value={rowsPerPage} onChange={handlePageSizeChange}>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      
      </div>
     
                        </div>
                    </div>
                </div>
                  </div>
                </div>
                </main>
        </>
      )
    }
  return (
    <Template>{videoGalleryScreen()}</Template>
  )
}

export default VideoGallery